import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import PrivateRoute, { homeDoPerfil } from './components/common/PrivateRoute';
import AppLayout from './components/layout/AppLayout';
import LoadingSpinner from './components/common/LoadingSpinner';

import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Clientes from './pages/clientes/Clientes';
import Usuarios from './pages/usuarios/Usuarios';
import Tipos from './pages/tipos/Tipos';
import Cores from './pages/cores/Cores';
import Tamanhos from './pages/tamanhos/Tamanhos';
import Modelos from './pages/modelos/Modelos';
import Estoque from './pages/estoque/Estoque';
import Demandas from './pages/demandas/Demandas';
import Pedidos from './pages/pedidos/Pedidos';
import PedidoDetalhe from './pages/pedidos/PedidoDetalhe';
import Catalogo from './pages/catalogo/Catalogo';
import CatalogoOperador from './pages/catalogo/CatalogoOperador';
import Carrinho from './pages/carrinho/Carrinho';
import MeusPedidos from './pages/meus-pedidos/MeusPedidos';
import Perfil from './pages/perfil/Perfil';
import Areas from './pages/areas/Areas';
import Empresas from './pages/empresas/Empresas';
import Logs from './pages/logs/Logs';
import PainelFinanceiro from './pages/financeiro/PainelFinanceiro';
import PainelCadastros from './pages/cadastros/PainelCadastros';
import PainelAuditoria from './pages/auditoria/PainelAuditoria';

function PrivateLayout({ children, perfil }) {
  return (
    <PrivateRoute perfil={perfil}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner fullPage />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeDoPerfil(user.perfil)} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <BrandingProvider>
      <AuthProvider>
        <Routes>
          {/* Público — /e/:slug/login mostra a marca daquela empresa; /login sem slug é
              a porta genérica da plataforma e nunca deve expor nome/logo de nenhuma
              empresa específica (ver Login.jsx + BrandingContext.resetToDefault) */}
          <Route path="/login" element={<Login />} />
          <Route path="/e/:slug/login" element={<Login />} />
          <Route path="/" element={<RootRedirect />} />

          {/* Operador / Gestor / Admin — gestor satisfaz perfil="operador" (ver PrivateRoute) */}
          <Route path="/dashboard" element={
            <PrivateLayout perfil="operador"><Dashboard /></PrivateLayout>
          }/>
          <Route path="/clientes" element={
            <PrivateLayout perfil="operador"><Clientes /></PrivateLayout>
          }/>
          <Route path="/usuarios" element={
            <PrivateLayout perfil={["gestor", "admin"]}><Usuarios /></PrivateLayout>
          }/>
          <Route path="/areas" element={
            <PrivateLayout perfil="operador"><Areas /></PrivateLayout>
          }/>
          <Route path="/tipos-uniforme" element={
            <PrivateLayout perfil="operador"><Tipos /></PrivateLayout>
          }/>
          <Route path="/cores-uniforme" element={
            <PrivateLayout perfil="operador"><Cores /></PrivateLayout>
          }/>
          <Route path="/tamanhos-uniforme" element={
            <PrivateLayout perfil="operador"><Tamanhos /></PrivateLayout>
          }/>
          <Route path="/modelos" element={
            <PrivateLayout perfil="operador"><Modelos /></PrivateLayout>
          }/>
          <Route path="/estoque" element={
            <PrivateLayout perfil="operador"><Estoque /></PrivateLayout>
          }/>
          <Route path="/demandas" element={
            <PrivateLayout perfil="operador"><Demandas /></PrivateLayout>
          }/>
          <Route path="/pedidos" element={
            <PrivateLayout perfil="operador"><Pedidos /></PrivateLayout>
          }/>
          <Route path="/pedidos/:id" element={
            <PrivateLayout perfil="operador"><PedidoDetalhe /></PrivateLayout>
          }/>
          <Route path="/catalogo-op" element={
            <PrivateLayout perfil="operador"><CatalogoOperador /></PrivateLayout>
          }/>
          <Route path="/empresas" element={
            <PrivateLayout perfil="admin"><Empresas /></PrivateLayout>
          }/>
          <Route path="/logs" element={
            <PrivateLayout perfil="admin"><Logs /></PrivateLayout>
          }/>
          <Route path="/painel-financeiro" element={
            <PrivateLayout perfil={["gestor", "admin"]}><PainelFinanceiro /></PrivateLayout>
          }/>
          <Route path="/painel-cadastros" element={
            <PrivateLayout perfil={["gestor", "admin"]}><PainelCadastros /></PrivateLayout>
          }/>
          <Route path="/painel-auditoria" element={
            <PrivateLayout perfil="admin"><PainelAuditoria /></PrivateLayout>
          }/>

          {/* Cliente */}
          <Route path="/catalogo" element={
            <PrivateLayout><Catalogo /></PrivateLayout>
          }/>
          <Route path="/carrinho" element={
            <PrivateLayout><Carrinho /></PrivateLayout>
          }/>
          <Route path="/meus-pedidos" element={
            <PrivateLayout><MeusPedidos /></PrivateLayout>
          }/>

          {/* Todos os perfis autenticados */}
          <Route path="/perfil" element={
            <PrivateLayout><Perfil /></PrivateLayout>
          }/>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  );
}
